import { setWindowLocationHref } from 'hs-browser-apis/location';

export function buildLoginRedirectUrl(redirectUrl?: string): string {
  const destination =
    redirectUrl ??
    `${window.location.origin}${window.location.pathname}${window.location.search}`;
  return `/_hcms/mem/login?redirect_url=${encodeURIComponent(destination)}`;
}

export function redirectToLogin(redirectUrl?: string): void {
  setWindowLocationHref(buildLoginRedirectUrl(redirectUrl));
}

export function redirectToAccessDenied(): void {
  window.location.replace('/_hcms/mem/denied');
}

export function buildIdleLogoutUrl(): string {
  return `/_hcms/mem/logout?redirect_url=${encodeURIComponent(
    window.location.href
  )}`;
}

export function redirectToIdleLogout(): void {
  window.location.href = buildIdleLogoutUrl();
}
